module.exports = __webpack_public_path__ + "img/bracelet.56492aa1.png";